// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.VirtualListWithKeyboard-module_menuContainer__aP5cM {
  max-height: 25rem;
}
.VirtualListWithKeyboard-module_empty__NkzmK {
  padding: 0.625rem;
}
`, "",{"version":3,"sources":["webpack://./app/components/VirtualListWithKeyboard/VirtualListWithKeyboard.module.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;AAVF;EACI,iBAAA;AAYJ;AATA;EACI,iBAAA;AAWJ","sourcesContent":["@import \"../../resources/styles/colors\";\n\n.menuContainer {\n    max-height: 400/16rem;\n}\n\n.empty {\n    padding: 10/16rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `VirtualListWithKeyboard-module_menuContainer__aP5cM`,
	"empty": `VirtualListWithKeyboard-module_empty__NkzmK`
};
module.exports = ___CSS_LOADER_EXPORT___;
